<template>
    <div class="sale-trend">      
      <div class="sale-table-bottom">
        <div class="jiegou-input">
          <span class="trend-title">本月业绩达成率</span>
          <el-input type="number" placeholder="请输入" v-model="rate.monthData">
            <template slot="suffix">%</template>
          </el-input>
        </div>
        <div class="jiegou-input">
          <span class="trend-title">全年业绩达成率</span>
          <el-input type="number" placeholder="请输入" v-model="rate.yearData">
            <template slot="suffix">%</template>
          </el-input>
        </div>
        <div class="jiegou-input">
          <span class="trend-title">业绩进步率</span>
          <el-input type="number" placeholder="请输入" v-model="rate.face">
            <template slot="suffix">%</template>
          </el-input>
        </div>
      </div>
      <table class="mytable">
        <thead>
          <tr>
            <th style="width:10%;">产品/月份</th>
            <th v-for="(mon,index) in month" :key="index">{{mon}}</th>
            <th>
              <i @click="addTrend" class="el-icon-circle-plus-outline f_green"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style="text-align:center;" v-if="tableDate.length==0">
            <td colspan="15">暂无数据</td>
          </tr>
          <tr v-else v-for="(msg,index) in tableDate" :key="index" >
            <td>
              <el-input v-model="msg.proName" placeholder="请输入名称"></el-input>
            </td>
            <td>
              <el-input v-model="msg.oneData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.twoData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.threeData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.fourData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.fiveData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.sixData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.sevenData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.eightData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.nineData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.tenData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.elevenData"></el-input>
            </td>
            <td>
              <el-input v-model="msg.twelveData"></el-input>
            </td>
            <td>
              <i @click="removeTrend(msg.id,index)" class="el-icon-remove-outline f_red"></i>
            </td>
          </tr>
        </tbody>
      </table>
      
      <div class="last-save">
         <el-button :loading="trendLoading" size="small" @click="saveAll" type="primary">保存</el-button>
      </div>
    </div>
</template>

<script>
import api from '@/apis/sale/sale'
export default {
  data() {
    return {
      trendLoading:false,//加载状态
      rate:{
        monthData:'',//本月业绩达成率
        yearData:'',//全年业绩达成率
        face:'',//业绩进步率
      },

      //通用循环数据
      month:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
      tableDate:[
        {
          proName:'',
          oneData:'',
          twoData:'',
          threeData:'',
          fourData:'',
          fiveData:'',
          sixData:'',
          sevenData:'',
          eightData:'',
          nineData:'',
          tenData:'',
          elevenData:'',
          twelveData:'',
        },
      ],
    }
  },
  mounted() {
    this.getList()
    this.getListDown()
  },
  methods: {
    //保存业绩趋势总共
    saveAll(){
      this.trendLoading = true;
      let obj = {}
      obj.saleAchieve = this.tableDate
      obj.saleAchieveFace = this.rate
      api.saveAchieve(obj).then(res=>{
        if(res.code==10000){
          this.trendLoading = false;
          this.getList()
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message)
          this.trendLoading = false;
          return;
        }
      })
    },
    //获取所有数据
    getList(){
      api.getAchieve().then(res=>{
        if(res.code==10000){
          if(res.data.length!=0){
            this.tableDate = res.data
          }else{
            this.tableDate = []
          }
        }
      })
    },
    getListDown(){
      api.getAchieveDown().then(res=>{
        if(res.code==10000){
          if(res.data.length!=0){
            this.rate = res.data[0]
          }
        }
      })
    },
    //删除一行数据
    removeTrend(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delAchieve([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getList()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.tableDate.splice(index,1)
      }
    },
    //添加一行数据
    addTrend(){
      this.tableDate.push(
        {
          proName:'',
          oneData:'',
          twoData:'',
          threeData:'',
          fourData:'',
          fiveData:'',
          sixData:'',
          sevenData:'',
          eightData:'',
          nineData:'',
          tenData:'',
          elevenData:'',
          twelveData:'',
        },
      )
    },
  }
}
</script>
<style lang="less" scoped>
.sale-trend{ padding-top: 10px;
  i{ font-size: 1.2rem;}
  .sale-table-bottom{ margin-bottom: 1rem;
    .jiegou-input{ display: inline-block; margin-right: 15px;
      .trend-title{ width: 8rem;}
      .el-input{ width: 10rem;}
    }
  }
}
</style>
